import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { Trash, CircleSlash2, AlertTriangle } from "lucide-react";

const icons = {
  trash: Trash,
  cancel: CircleSlash2,
  warning: AlertTriangle,
};

const ConfirmDialog = ({ open, onClose, onConfirm, title, message, icon }) => {
  const IconComponent = icons[icon] || null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || "Confirmación"}</DialogTitle>
      <DialogContent>
        {IconComponent && (
          <div className="flex justify-center mb-2">
            <IconComponent size={52} color="#ff0000" strokeWidth={2.25} />
          </div>
        )}
        <Typography>{message || "¿Estás seguro de realizar esta acción?"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
